import React, { useContext, useState, useEffect } from "react";
import './Header.css';
/* ReactScroll */
import { Link } from 'react-scroll';

/* React router */
import { NavLink } from 'react-router-dom';

/* DarkMode */
import DarkMode from '../DarkMode/DarkMode';

/* Language */
import { FormattedMessage } from "react-intl";
import { langContext } from '../../context/Context';

const Header = () => {
    // Buttom language
    const idioma = useContext(langContext);
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    // Handle scroll effect
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Menu desplegable
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    // Close menu when clicking on a link
    const handleLinkClick = () => {
        setIsMenuOpen(false);
    };

    return (
        <header className={`site-header ${isScrolled ? 'scrolled' : ''} ${isMenuOpen ? 'menu-open' : ''}`}>
            <div className="header-container">
                <NavLink className="logo" to="/" onClick={handleLinkClick}>
                    <div className="logo-container">
                        <span className="logo-bracket">=</span>
                        <span className="logo-name">ArunSingh</span>
                        <span className="logo-bracket">=</span>
                    </div>
                </NavLink>

                <div 
                    id="menu-btn" 
                    className={`menu-toggle ${isMenuOpen ? 'active' : ''}`}
                    onClick={toggleMenu}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <nav className={`navbar ${isMenuOpen ? 'active' : ''}`}>
                    <Link 
                        to="inicio" 
                        spy={true} 
                        offset={-150} 
                        href="#inicio"
                        onClick={handleLinkClick}
                    >
                        <FormattedMessage
                            id='home'
                            defaultMessage='Home'
                        />
                    </Link>
                    <Link 
                        to="sobre-mi" 
                        spy={true} 
                        offset={-150} 
                        href="#sobre-mi"
                        onClick={handleLinkClick}
                    >
                        <FormattedMessage
                            id='about'
                            defaultMessage='About me'
                        />
                    </Link>
        
                    <Link 
                        to="contactos" 
                        spy={true} 
                        offset={-150} 
                        href="#contactos"
                        onClick={handleLinkClick}
                    >
                        <FormattedMessage
                            id='contact'
                            defaultMessage='Contact'
                        />
                    </Link>
                    <Link 
                        to="proyectos" 
                        spy={true} 
                        offset={-150} 
                        href="#proyectos"
                        onClick={handleLinkClick}
                    >
                        <FormattedMessage
                            id='projects'
                            defaultMessage='Projects'
                        />
                    </Link>
                    {/* Add Project Videos as a NavLink (since it's a separate page) */}
                    <NavLink 
                        to="/project-videos" 
                        onClick={handleLinkClick}
                        className={({ isActive }) => isActive ? 'active' : ''}
                    >
                        <FormattedMessage
                            id='projectVideos'
                            defaultMessage='Project Videos'
                        />
                    </NavLink>
                    
                    <div className="header-controls">
                        <div id="buttons">
                            <img 
                                onClick={() => {
                                    idioma.selectLanguage('en-IN');
                                    handleLinkClick();
                                }} 
                                src="https://th.bing.com/th/id/R.607b9f69862d76af04b474113c0c7ff5?rik=lfnOsbv7mhDNbQ&riu=http%3a%2f%2fupload.wikimedia.org%2fwikipedia%2fcommons%2fb%2fbc%2fFlag_of_India.png&ehk=Pk5lH0C%2fhstFahWfb15vLjtrJb3DslIU4%2fAQneo9IIM%3d&risl=&pid=ImgRaw&r=0" 
                                alt="INDIA" 
                                className="language-flag"
                            />   
                        </div>
                        <div className="switch" id="switch">
                            <DarkMode />
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    )
}

export default React.memo(Header);